import React from 'react';
import { FadeInSection } from './ui/FadeInSection';
import { XCircle, Zap, ArrowRight } from 'lucide-react';
export function SolutionReveal() {
  return <>
      {/* SECTION 6 — WHY THEY FAIL */}
      <section className="bg-cream px-4 py-16 md:py-24" data-id="element-262">
        <div className="max-w-3xl mx-auto" data-id="element-263">
          <FadeInSection data-id="element-264">
            <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mb-12" data-id="element-265">
              {[{
              title: 'DIETAS SIN AZÚCAR',
              desc: 'Suprimir no es resolver. El antojo vuelve con el doble de intensidad. Siempre.'
            }, {
              title: 'RECETARIOS FIT DE INSTAGRAM',
              desc: 'Diseñados para otro mercado. Ingredientes imposibles de conseguir. Recetas que no saben a nada.'
            }, {
              title: 'LA NUTRICIONISTA TRADICIONAL',
              desc: 'El plan funciona mientras pagás. Cuando el seguimiento termina, los hábitos también.'
            }, {
              title: 'LA FUERZA DE VOLUNTAD',
              desc: 'Es un recurso finito. Para la noche ya está agotada. Pelear contra tu biología no es una estrategia. Es un desgaste.'
            }].map((card, idx) => <div key={idx} className="bg-white p-6 rounded-2xl shadow-sm border border-cream-dark hover:shadow-warm transition-shadow" data-id="element-266">
                  <div className="flex items-center gap-2 mb-3" data-id="element-267">
                    <XCircle className="w-6 h-6 text-urgency shrink-0" data-id="element-268" />
                    <h4 className="font-bold text-chocolate" data-id="element-269">{card.title}</h4>
                  </div>
                  <p className="text-textBody text-sm md:text-base" data-id="element-270">
                    {card.desc}
                  </p>
                </div>)}
            </div>

            <div className="text-center border-t border-gold/30 pt-10" data-id="element-271">
              <p className="text-xl text-textBody mb-2" data-id="element-272">
                Todas te piden que luches contra tu cuerpo.
              </p>
              <p className="text-2xl font-bold text-chocolate" data-id="element-273">
                El Método Antídoto hace lo opuesto.
              </p>
            </div>
          </FadeInSection>
        </div>
      </section>

      {/* SECTION 7 — UNIQUE MECHANISM */}
      <section className="bg-chocolate text-cream px-4 py-16 md:py-24 relative overflow-hidden" data-id="element-274">
        <div className="absolute top-1/2 left-0 w-full h-px bg-gradient-to-r from-transparent via-gold/20 to-transparent" data-id="element-275"></div>

        <div className="max-w-3xl mx-auto relative z-10" data-id="element-276">
          <FadeInSection className="text-center mb-12" data-id="element-277">
            <p className="text-xl md:text-2xl mb-4" data-id="element-278">
              Hay una razón científica por la que
              <br data-id="element-279" />
              tu cerebro pide dulce todos los días.
            </p>
            <h2 className="text-3xl md:text-4xl lg:text-5xl font-black text-gold tracking-wide" data-id="element-280">
              Se llama DÉFICIT PROTEICO FUNCIONAL.
            </h2>
          </FadeInSection>

          <FadeInSection delay={200} className="max-w-2xl mx-auto text-center mb-16" data-id="element-281">
            <p className="text-lg md:text-xl text-warmWhite/90 mb-6" data-id="element-282">
              Cuando no recibís suficiente proteína en el momento correcto...
              <br data-id="element-283" />
              tu cerebro activa una señal de emergencia:
            </p>
            <p className="text-2xl font-bold text-gold italic mb-6" data-id="element-284">
              "Dame glucosa. Ahora."
            </p>
            <p className="text-lg text-warmWhite/80" data-id="element-285">
              No hay dieta ni voluntad que apague esa señal.
              <br data-id="element-286" />
              Solo la proteína correcta en el momento correcto.
            </p>
          </FadeInSection>

          <FadeInSection delay={400} data-id="element-287">
            <div className="bg-chocolate-light border border-gold/30 rounded-3xl p-8 md:p-12 shadow-2xl relative" data-id="element-288">
              <div className="absolute -top-6 left-1/2 -translate-x-1/2 bg-gold text-chocolate px-6 py-2 rounded-full font-bold flex items-center gap-2 shadow-gold" data-id="element-289">
                <Zap className="w-5 h-5" data-id="element-290" />
                EL ANTÍDOTO
              </div>

              <div className="text-center mt-4 mb-8" data-id="element-291">
                <p className="text-xl mb-4" data-id="element-292">
                  En lugar de pelear contra ese mecanismo...
                  <br data-id="element-293" />
                  lo hackeamos.
                </p>
                <div className="inline-block bg-chocolate px-6 py-4 rounded-xl border border-gold/20" data-id="element-294">
                  <p className="text-lg md:text-xl font-bold text-gold" data-id="element-295">
                    Dulce real + fórmula proteica exacta
                    <br data-id="element-296" />
                    <span className="text-warmWhite" data-id="element-297">
                      = antojo apagado en 3 minutos.
                    </span>
                  </p>
                </div>
              </div>

              <ul className="space-y-4 max-w-md mx-auto" data-id="element-298">
                {['Disfrutás el dulce de verdad.', 'Tu cerebro registra saciedad real.', 'El ciclo de culpa se rompe.'].map((item, idx) => <li key={idx} className="flex items-center gap-3 text-lg" data-id="element-299">
                    <ArrowRight className="w-6 h-6 text-gold shrink-0" data-id="element-300" />
                    <span className="font-medium" data-id="element-301">{item}</span>
                  </li>)}
              </ul>
            </div>
          </FadeInSection>
        </div>
      </section>

      {/* SECTION 8 — ORIGIN STORY */}
      <section className="bg-warmWhite px-4 py-16 md:py-20" data-id="element-302">
        <div className="max-w-2xl mx-auto text-center" data-id="element-303">
          <FadeInSection data-id="element-304">
            <p className="text-xl text-chocolate-light mb-6" data-id="element-305">
              Este Sistema no nació en un laboratorio.
            </p>
            <p className="text-lg text-textBody mb-10" data-id="element-306">
              Nació de 14 meses trabajando con más de 200 mujeres argentinas que
              ya habían probado todo.
              <br data-id="element-307" />
              <br data-id="element-308" />
              Lo que descubrimos fue consistente:
            </p>

            <div className="bg-cream p-8 rounded-2xl border-l-4 border-gold shadow-sm text-left" data-id="element-309">
              <p className="text-xl md:text-2xl font-bold text-chocolate leading-relaxed mb-4" data-id="element-310">
                Cuando combinamos el dulce real con el soporte proteico
                correcto...
                <br data-id="element-311" />
                el ciclo culpa — antojo — culpa se rompía en menos de 21 días.
              </p>
              <p className="text-lg font-bold text-gold" data-id="element-312">Sin excepción.</p>
            </div>
          </FadeInSection>
        </div>
      </section>
    </>;
}